import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  IconButton,
  Grid
} from '@mui/material';
import { FilterList, ExpandMore, ExpandLess, Check, RotateLeft, Close } from '@mui/icons-material';

const MoreFilters = ({
  expanded,
  onToggle,
  sortBy = '',
  onChangeSortBy = () => { },
  onApply = () => { },
  onReset = () => { },
  buttonLabel = "More Filters",
  type = "customer",
  height = "56px",
  children
}) => {

  const sortOptions = type === 'associate' ? [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'selfBusinessDesc', label: 'Self Business (H → L)' },
    { value: 'selfBusinessAsc', label: 'Self Business (L → H)' },
    { value: 'totalBusinessDesc', label: 'Total Business (H → L)' },
    { value: 'totalBusinessAsc', label: 'Total Business (L → H)' },
    { value: 'commissionDesc', label: 'Commission (H → L)' },
    { value: 'commissionAsc', label: 'Commission (L → H)' },
  ] : type === 'commission' ? [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'commissionDesc', label: 'Commission (H → L)' },
    { value: 'commissionAsc', label: 'Commission (L → H)' },
    { value: 'sponsorCommissionDesc', label: 'Sponsor Comm (H → L)' },
    { value: 'sponsorCommissionAsc', label: 'Sponsor Comm (L → H)' },
  ] : type === 'commissionGeneration' ? [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'payableCommissionAmountDesc', label: 'Payable Comm (H → L)' },
    { value: 'payableCommissionAmountAsc', label: 'Payable Comm (L → H)' },
    { value: 'paymentAmountDesc', label: 'Payment Amt (H → L)' },
    { value: 'paymentAmountAsc', label: 'Payment Amt (L → H)' },
  ] : type === 'commissionReport' ? [
    { value: 'commissionPercentDesc', label: 'Comm % (H → L)' },
    { value: 'commissionPercentAsc', label: 'Comm % (L → H)' },
    { value: 'commissionAmountDesc', label: 'Comm Amt (H → L)' },
    { value: 'commissionAmountAsc', label: 'Comm Amt (L → H)' },
    { value: 'dueAmountDesc', label: 'Due Amt (H → L)' },
    { value: 'dueAmountAsc', label: 'Due Amt (L → H)' },
    { value: 'paidAmountDesc', label: 'Paid Amt (H → L)' },
    { value: 'paidAmountAsc', label: 'Paid Amt (L → H)' },
  ] : type === 'project' ? [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
  ] : type === 'inventory' ? [
    { value: 'amountAsc', label: 'Amount (L → H)' },
    { value: 'amountDesc', label: 'Amount (H → L)' },
  ] : type === 'tds' ? [
    { value: 'totalTdsDesc', label: 'Total TDS (H → L)' },
    { value: 'totalTdsAsc', label: 'Total TDS (L → H)' },
    { value: 'totalAmountDesc', label: 'Total Amount (H → L)' },
    { value: 'totalAmountAsc', label: 'Total Amount (L → H)' },
    { value: 'tdsPercentDesc', label: 'TDS % (H → L)' },
    { value: 'tdsPercentAsc', label: 'TDS % (L → H)' },
  ] : type === 'bookingCommission' ? [
    { value: 'receivedDateDesc', label: 'Received Date (Newest)' },
    { value: 'receivedDateAsc', label: 'Received Date (Oldest)' },
    { value: 'plotAmountDesc', label: 'Plot Amount (H → L)' },
    { value: 'plotAmountAsc', label: 'Plot Amount (L → H)' },
    { value: 'commissionGeneratedAmountDesc', label: 'Generated Comm (H → L)' },
    { value: 'commissionGeneratedAmountAsc', label: 'Generated Comm (L → H)' },
    { value: 'netCommissionPercentDesc', label: 'Net Comm % (H → L)' },
    { value: 'netCommissionPercentAsc', label: 'Net Comm % (L → H)' },
    { value: 'netCommissionAmountDesc', label: 'Net Comm Amt (H → L)' },
    { value: 'netCommissionAmountAsc', label: 'Net Comm Amt (L → H)' },
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'createdAtDesc', label: 'Created At (Newest)' },
    { value: 'createdAtAsc', label: 'Created At (Oldest)' },
  ] : type === 'bookingReport' ? [
    { value: 'bookingDateDesc', label: 'Booking Date (Newest)' },
    { value: 'bookingDateAsc', label: 'Booking Date (Oldest)' },
    { value: 'propertyAmountDesc', label: 'Property Amount (H → L)' },
    { value: 'propertyAmountAsc', label: 'Property Amount (L → H)' },
    { value: 'totalDueAmountDesc', label: 'Total Due Amount (H → L)' },
    { value: 'totalDueAmountAsc', label: 'Total Due Amount (L → H)' },
    { value: 'excludeVdatotalDueAmountDesc', label: 'Exclude VDA Due (H → L)' },
    { value: 'excludeVdatotalDueAmountAsc', label: 'Exclude VDA Due (L → H)' },
    { value: 'paidAmountDesc', label: 'Paid Amount (H → L)' },
    { value: 'paidAmountAsc', label: 'Paid Amount (L → H)' },
  ] : type === 'booking' ? [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'propertyAmountDesc', label: 'Property Amount (H → L)' },
    { value: 'propertyAmountAsc', label: 'Property Amount (L → H)' },
  ] : type === 'bookingReceipt' ? [
    { value: 'receiptDateDesc', label: 'Receipt Date (Newest)' },
    { value: 'receiptDateAsc', label: 'Receipt Date (Oldest)' },
    { value: 'netAmountDesc', label: 'Amount (H → L)' },
    { value: 'netAmountAsc', label: 'Amount (L → H)' },
    { value: 'createdAtDesc', label: 'Created At (Newest)' },
    { value: 'createdAtAsc', label: 'Created At (Oldest)' },
  ] : type === 'receipt' ? [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'amountDesc', label: 'Amount (H → L)' },
    { value: 'amountAsc', label: 'Amount (L → H)' },
  ] : type === 'cancelReport' ? [
    { value: 'bookingDateDesc', label: 'Booking Date (Newest)' },
    { value: 'bookingDateAsc', label: 'Booking Date (Oldest)' },
    { value: 'cancelDateDesc', label: 'Cancel Date (Newest)' },
    { value: 'cancelDateAsc', label: 'Cancel Date (Oldest)' },
    { value: 'propertyAmountDesc', label: 'Property Amt (H → L)' },
    { value: 'propertyAmountAsc', label: 'Property Amt (L → H)' },
    { value: 'refundedAmountDesc', label: 'Refund Amt (H → L)' },
    { value: 'refundedAmountAsc', label: 'Refund Amt (L → H)' },
  ] : type === 'leadReport' ? [
    { value: 'leadDateDesc', label: 'Lead Date (Newest)' },
    { value: 'leadDateAsc', label: 'Lead Date (Oldest)' },
    { value: 'followUpDateDesc', label: 'Follow-Up Date (Newest)' },
    { value: 'followUpDateAsc', label: 'Follow-Up Date (Oldest)' },
    { value: 'customerNameAsc', label: 'Customer Name (A → Z)' },
    { value: 'customerNameDesc', label: 'Customer Name (Z → A)' },
  ] : type === 'totalDue' ? [
    { value: 'totalDueDesc', label: 'Due Amount (H → L)' },
    { value: 'totalDueAsc', label: 'Due Amount (L → H)' },
    { value: 'totalAmountDesc', label: 'Property Amount (H → L)' },
    { value: 'totalAmountAsc', label: 'Property Amount (L → H)' },
    // { value: 'totalBookingAmountDesc', label: 'Booking Amount (H → L)' },
    // { value: 'totalBookingAmountAsc', label: 'Booking Amount (L → H)' },
    { value: 'totalReceivedDesc', label: 'Received Amount (H → L)' },
    { value: 'totalReceivedAsc', label: 'Received Amount (L → H)' },
  ] : type === 'totalDueBookings' ? [
    { value: 'totalDueAmountDesc', label: 'Due Amount (H → L)' },
    { value: 'totalDueAmountAsc', label: 'Due Amount (L → H)' },
    { value: 'bookingDateDesc', label: 'Booking Date (Newest)' },
    { value: 'bookingDateAsc', label: 'Booking Date (Oldest)' },
  ] : type === 'branchWiseSummary' ? [
    { value: 'totalBookingAmountDesc', label: 'Total Amt (H → L)' },
    { value: 'totalBookingAmountAsc', label: 'Total Amt (L → H)' },
    { value: 'totalPaidAmountDesc', label: 'Paid Amt (H → L)' },
    { value: 'totalPaidAmountAsc', label: 'Paid Amt (L → H)' },
    { value: 'totalDueAmountDesc', label: 'Due Amt (H → L)' },
    { value: 'totalDueAmountAsc', label: 'Due Amt (L → H)' },
    { value: 'totalBookingsDesc', label: 'Bookings (H → L)' },
    { value: 'totalBookingsAsc', label: 'Bookings (L → H)' },
  ] : type === 'plotInventory' ? [
    { value: 'amountDesc', label: 'Amount (H → L)' },
    { value: 'amountAsc', label: 'Amount (L → H)' },
    { value: 'totalPlotAmountDesc', label: 'Total Plot Amt (H → L)' },
    { value: 'totalPlotAmountAsc', label: 'Total Plot Amt (L → H)' },
    { value: 'circleRateDesc', label: 'Circle Rate (H → L)' },
    { value: 'circleRateAsc', label: 'Circle Rate (L → H)' },
    { value: 'totalSizeDesc', label: 'Total Size (H → L)' },
    { value: 'totalSizeAsc', label: 'Total Size (L → H)' },
  ] : type === 'adminPayment' ? [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'amountDesc', label: 'Amount (H → L)' },
    { value: 'amountAsc', label: 'Amount (L → H)' },
  ] : type === 'siteVisit' ? [
    { value: 'desc', label: 'Date (Newest)' },
    { value: 'asc', label: 'Date (Oldest)' },
    { value: 'timelineCountDesc', label: 'Timeline Count (H → L)' },
    { value: 'timelineCountAsc', label: 'Timeline Count (L → H)' },
    { value: 'all', label: 'None' },
  ] : type === 'lead' ? [
    { value: 'desc', label: 'Date (Newest)' },
    { value: 'asc', label: 'Date (Oldest)' },
    { value: 'all', label: 'None' },
  ] : [
    { value: 'dateDesc', label: 'Date (Newest)' },
    { value: 'dateAsc', label: 'Date (Oldest)' },
    { value: 'nameAsc', label: 'Name (A → Z)' },
    { value: 'nameDesc', label: 'Name (Z → A)' },
    { value: 'spentDesc', label: 'Spent (High → Low)' },
    { value: 'spentAsc', label: 'Spent (Low → High)' },
    { value: 'dueDesc', label: 'Due (High → Low)' },
    { value: 'dueAsc', label: 'Due (Low → High)' },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      {/* Toggle Button */}
      <Box sx={{ display: 'flex' }}>
        <Button
          variant="outlined"
          onClick={onToggle}
          startIcon={<FilterList />}
          endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 2,
            borderColor: '#536DFE',
            color: '#536DFE',
            px: 2.5,
            py: 0.8,
            height: height,
            width: '100%',
            '&:hover': {
              borderColor: '#3F51B5',
              backgroundColor: 'rgba(83, 109, 254, 0.04)',
            }
          }}
        >
          {buttonLabel}
        </Button>
      </Box>

      {/* Centered Dialog advanced filter panel */}
      <Dialog
        open={expanded}
        onClose={onToggle}
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 16px 48px rgba(83, 109, 254, 0.15), 0 2px 12px rgba(0,0,0,0.06)',
            width: '440px',
            maxWidth: '95vw',
          }
        }}
      >
        {/* Gradient Header */}
        <Box sx={{
          background: 'linear-gradient(135deg, #536DFE 0%, #3F51B5 100%)',
          px: 3, py: 2.2,
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box sx={{ position: 'absolute', top: -10, right: -10, width: 45, height: 45, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.08)' }} />
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#fff', fontSize: '1.05rem', lineHeight: 1.2 }}>
            More Filters & Sorting
          </Typography>
          <IconButton
            onClick={onToggle}
            size="small"
            sx={{
              position: 'absolute',
              right: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#fff',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.25)',
              }
            }}
          >
            <Close sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>

        <DialogContent sx={{ p: 3, pb: 1.5 }}>
          {/* Sorting Options Section */}
          <FormControl component="fieldset" sx={{ width: '100%' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#444', mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
              <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', backgroundColor: '#536DFE' }}></span>
              Sort By
            </Typography>
            <RadioGroup
              value={sortBy}
              onChange={(e) => onChangeSortBy(e.target.value)}
              sx={{ width: '100%' }}
            >
              <Grid container spacing={1.5}>
                {sortOptions.map((opt) => (
                  <Grid item xs={6} key={opt.value}>
                    <Box sx={{
                      border: '1px solid',
                      borderColor: sortBy === opt.value ? '#536DFE' : '#e0e0e0',
                      borderRadius: 2,
                      px: 1,
                      py: 0.5,
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: sortBy === opt.value ? 'rgba(83, 109, 254, 0.04)' : '#fff',
                      transition: 'all 0.2s',
                      '&:hover': { borderColor: '#536DFE', backgroundColor: 'rgba(83, 109, 254, 0.02)' }
                    }}>
                      <FormControlLabel
                        value={opt.value}
                        control={<Radio size="small" sx={{ color: '#c5cae9', '&.Mui-checked': { color: '#536DFE' } }} />}
                        label={<Typography sx={{ fontSize: '0.8rem', fontWeight: sortBy === opt.value ? 600 : 500, color: '#333' }}>{opt.label}</Typography>}
                        sx={{ m: 0, width: '100%' }}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </RadioGroup>
          </FormControl>

          {/* Divider if children exist */}
          {children && (
            <>
              <Divider sx={{ my: 2.5, borderStyle: 'dashed' }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#444', mb: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
                <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', backgroundColor: '#536DFE' }}></span>
                Advanced Filters
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {children}
              </Box>
            </>
          )}
        </DialogContent>

        <Divider sx={{ mx: 3, my: 0.5 }} />

        {/* Action Buttons */}
        <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1.5, justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            onClick={onReset}
            startIcon={<RotateLeft />}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
              flex: 1,
              py: 1,
              borderColor: '#c5cae9',
              color: '#536DFE',
              '&:hover': {
                borderColor: '#536DFE',
                backgroundColor: 'rgba(83, 109, 254, 0.04)',
              }
            }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              onApply();
              onToggle(); // Close the dialog on Apply
            }}
            startIcon={<Check />}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: 2,
              flex: 1,
              py: 1,
              backgroundColor: '#536DFE',
              boxShadow: '0 4px 12px rgba(83, 109, 254, 0.2)',
              '&:hover': {
                backgroundColor: '#3F51B5',
                boxShadow: '0 6px 16px rgba(83, 109, 254, 0.3)',
              }
            }}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MoreFilters;
